import { View } from 'react-native';
import ActionSheet from 'react-native-actions-sheet';
import lodashIsUndefined from 'lodash/isUndefined';

import RatingSelector from '../Filter/RatingSelector';

import commonProps from './commonProps';
import modals from './modals';
import styles from './styles';

const defaultValue = 4;
function RatingSelectorSheet({ sheetId, payload }) {
  const disableReset = lodashIsUndefined(payload.value);

  const _onButtonPress = (rating) =>
    modals.hide(modals.RATING_SELECTOR, rating ? { value: rating } : null);

  return (
    <ActionSheet id={sheetId} {...commonProps}>
      <View style={styles.contentContainer}>
        <RatingSelector
          disableReset={disableReset}
          rating={disableReset ? defaultValue : payload.value?.value}
          onViewResult={_onButtonPress}
          onReset={() => _onButtonPress()}
        />
      </View>
    </ActionSheet>
  );
}

export default RatingSelectorSheet;
